import axios from 'axios';

import baseURL from '../../services/apiBaseUrl';

const TOKEN_KEY = 'studentPortalToken';

export function getStudentToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setStudentToken(token) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export function clearStudentSession() {
  sessionStorage.removeItem(TOKEN_KEY);
}

const studentApi = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

studentApi.interceptors.request.use((config) => {
  const token = getStudentToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function studentLogin(phone, personalCode) {
  const { data } = await studentApi.post('/student-portal/login', { phone, personalCode });
  setStudentToken(data.token);
  return data;
}

export async function fetchStudentMe() {
  const { data } = await studentApi.get('/student-portal/me');
  return data;
}

export async function fetchStudentMeta() {
  const { data } = await studentApi.get('/student-portal/meta');
  return data;
}

export async function fetchStudentGrades() {
  const { data } = await studentApi.get('/student-portal/grades');
  return data;
}

export async function updateStudentPhone(phone) {
  const { data } = await studentApi.patch('/student-portal/phone', { phone });
  return data;
}

export async function updateStudentProfile(payload) {
  const { data } = await studentApi.patch('/student-portal/profile', payload);
  return data;
}

export async function saveStudentRegistration(payload) {
  const { data } = await studentApi.post('/student-portal/registration', payload);
  return data;
}

export async function fetchRegisterMeta() {
  const { data } = await studentApi.get('/student-portal/register-meta');
  return data;
}

export async function submitNewExamineeRegistration(payload) {
  const { data } = await studentApi.post('/student-portal/register', payload);
  return data;
}

export default studentApi;
